import {isStringOrNumberNotEmpty} from '../utils';
import Icon from '../icon';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    let {
    type, className, size, icon, circle, ref, key, tabindex,
    tagName, htmlType, fluid, children, loading, disabled,
    value, _value, name, tagProps, _checkType, ghost, ...rest
} = self.get();

const checked = value !== undefined ?
    _checkType === 'radio' ? 
        value === _value :  
        (
            _checkType === 'checkbox' ? 
                Array.isArray(_value) && !!~_value.indexOf(value) :
                false
        )
    : false;

const classNameObj = {
    'k-btn': true,
    [`k-${type}`]: type,
    'k-btn-icon': icon,
    [className]: className, 
    'k-circle': circle,
    'k-loading': loading,
    'k-fluid': fluid,
    'k-active': checked,
    'k-disabled': disabled || loading,
    'k-ghost': ghost,
};
// type and size may both be default
if (size !== 'default') classNameObj[`k-${size}`] = true;

const Button = props => {
    if (props.href && tagName === 'button') {
        tagName = 'a';
    }
    if (tagName === 'button') {
        // set type of html button
        props.type = htmlType;
    }
    // disable button when loading
    /* if (loading) props.disabled = true; */
    return h(tagName, props, props.children);
};

// hack for loading transition of width
if (!icon && Array.isArray(children)) {
    children.forEach((child, index) => {
        if (child) {
            if (child.type === 1 || isStringOrNumberNotEmpty(child)) {
                // is a text node
                // wrap text node with span
                children[index] = h('span', null, function() {try {return (child )} catch(e) {_e(e)}}.call($this))
            }
            // whether the icon is on the left side or right
            if (index === 0) {
                if (child.tag === Icon || child.className && child.className.indexOf('icon') > -1) {
                    classNameObj['k-btn-icon-left'] = true;
                }
            } else if (index === children.length - 1) {
                if (child.tag === Icon || child.className && child.className.indexOf('icon') > -1) {
                    classNameObj['k-btn-icon-right'] = true;
                }
            }
        }
    });
} else if (isStringOrNumberNotEmpty(children) || children && children.type === 1) {
    // wrap text node with span
    children = h('span', null, function() {try {return (children )} catch(e) {_e(e)}}.call($this))
}

/* const loadingSizeMap = { */
    /* 'large': 'default', */
    /* 'default': 'small', */
    /* 'small': 'mini', */
    /* 'mini': 'mini' */
/* }; */
const loadingIcon = (
    h(Icon, {
        'className': 'ion-load-c icon-loading',
        'size': function() {try {return (size /*loadingSizeMap[size]*/ )} catch(e) {_e(e)}}.call($this),
        'key': 'k-loading',
        '_context': $this
    })
);

    return h(Button, {
        'className': _className(function() {try {return (classNameObj )} catch(e) {_e(e)}}.call($this)),
        ...function() {try {return (rest )} catch(e) {_e(e)}}.call($this),
        ...function() {try {return (tagProps )} catch(e) {_e(e)}}.call($this),
        'tabindex': function() {try {return (disabled || loading ? "-1" : tabindex )} catch(e) {_e(e)}}.call($this),
        'children': [
            function() {try {return (loading ? 
        classNameObj['k-btn-icon-right'] ?
            [children, loadingIcon] :
            [loadingIcon, children] :
        children 
    )} catch(e) {_e(e)}}.call($this),
            function() {try {return (_checkType !== 'none' )} catch(e) {_e(e)}}.call($this) ?
                h('input', {
                    'type': function() {try {return (_checkType )} catch(e) {_e(e)}}.call($this),
                    'name': function() {try {return (name )} catch(e) {_e(e)}}.call($this),
                    'checked': function() {try {return (checked )} catch(e) {_e(e)}}.call($this),
                    'tabindex': '-1'
                }) :
                undefined
        ],
        '_context': $this,
        'ev-click': function() {try {return (self._onClick )} catch(e) {_e(e)}}.call($this),
        'ev-mouseup': function() {try {return (self._onMouseUp )} catch(e) {_e(e)}}.call($this)
    })
}